import { render, staticRenderFns } from "./PesquisaCapacitacaoDigital.vue?vue&type=template&id=3701166a&scoped=true"
import script from "./PesquisaCapacitacaoDigital.vue?vue&type=script&lang=js"
export * from "./PesquisaCapacitacaoDigital.vue?vue&type=script&lang=js"
import style0 from "./PesquisaCapacitacaoDigital.vue?vue&type=style&index=0&id=3701166a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701166a",
  null
  
)

export default component.exports